module.exports = __webpack_public_path__ + "static/media/Primate-House.50664dd8.jpg";